import * as ng from 'angular';
import * as Linq from 'linq-es5';
import { IToastMessageService } from '../../../services';
import { Dto, IProfileResource } from '../../../data';
import { IUserResource } from '../../security';
import { ISiteConfigService } from '../../../core';

let UserAdminServiceFactory: Function =
    function ($q: ng.IQService,
        User: IUserResource,
        Profile: IProfileResource,
        toastMessageFactory: IToastMessageService,
        SiteConfig: ISiteConfigService): IUserAdminService {
        return new UserAdminService($q, User, Profile, toastMessageFactory, SiteConfig);
    }

UserAdminServiceFactory.$inject = ['$q', 'User', 'Profile', 'toastMessageFactory', 'SiteConfig'];

let UserAdminServices = {
    name: "UserAdmin",
    factory: UserAdminServiceFactory
};

interface IUserAdminService {
    search(criteria: Dto.IProfileCriteria): ng.IPromise<Array<Dto.IProfile>>;
    update(profile: Dto.IProfile): ng.IPromise<Dto.IProfile>;
    save(profile: Dto.IProfile): ng.IPromise<Dto.IProfile>;
    exists(username: string): ng.IPromise<boolean>;
    sendInvite(userId: string, username: string): ng.IPromise<boolean>;
    unlockUser(userId: string): ng.IPromise<boolean>;
}

export class UserAdminService implements IUserAdminService {

    constructor(private $q: ng.IQService,
        private User: IUserResource,
        private Profile: IProfileResource,
        private toastMessageFactory: IToastMessageService,
        private SiteConfig: ISiteConfigService) {

        console.log('UserAdminService loading');

        //activate service
        this.activate();
    }

    //functions
    public activate(): void {
        console.log('UserAdminService loaded');
    }

    public search(criteria: Dto.IProfileCriteria): ng.IPromise<Array<Dto.IProfile>> {
        let localCriteria = criteria || {} as Dto.IProfileCriteria;

        return this.Profile.search(localCriteria).$promise
            .then((response) => {
                return this.$q.resolve(response);
            })
            .catch((e) => {
                //this.toastMessageFactory.showServerError();
                return this.$q.resolve([]);
            });
    }

    public update(profile: Dto.IProfile): ng.IPromise<Dto.IProfile> {

        return this.Profile.updateAdmin(profile).$promise
            .then((response) => {
                this.toastMessageFactory.showSuccessMessage();
                return response;
            })
            .catch((e) => {
                //this.toastMessageFactory.showServerError();
                return this.$q.reject(e);
            });

    }

    public save(profile: Dto.IProfile): ng.IPromise<Dto.IProfile> {
        return this.SiteConfig.getConfigAsync().then((config) => {
            let params = {
                resetPasswordUri: config.baseUri + "/#/reset-password"
            };
            return this.Profile.saveAdmin(params, profile).$promise
                .then((response) => {
                    if (response.passwordResetEmailWasSent)
                        this.toastMessageFactory.showSuccessMessage();
                    else
                        this.toastMessageFactory.showWarningMessage('User was saved, however failed to send password reset email. Please verify the email service and "Password Reset" email template are configured properly and that the email server is running!');
                    return response;
                })
                .catch((e) => {
                    //this.toastMessageFactory.showServerError();
                    return this.$q.reject(e);
                });
        });
    }

    public exists(username: string): ng.IPromise<boolean> {
        return this.User.userExists({ username: username }).$promise
            .then((response) => {
                return (response as any).exists === "true";
            });
    }

    public sendInvite(userId: string, username: string): ng.IPromise<boolean> {
        return this.SiteConfig.getConfigAsync().then((config) => {
            let request = {
                id: userId,
                username: username,
                baseUri: config.baseUri + "/#/reset-password"
            };

            return this.User.sendInvite(request).$promise
                .then((response) => {
                    this.toastMessageFactory.showSuccessMessage("Invite Sent successfully.");
                    return response;
                });
        });
    }

    public unlockUser(userId: string): ng.IPromise<boolean> {
        return this.SiteConfig.getConfigAsync().then((config) => {
            let request = {
                id: userId
            };

            return this.User.unlockUser(request).$promise
                .then((response) => {
                    this.toastMessageFactory.showSuccessMessage("User was successfully unlocked.");
                    return response;
                })
                .catch((e) => {
                    this.toastMessageFactory.showServerError();
                    console.log(e);
                    return this.$q.reject(e);
                });;
        });
    }
}

export { UserAdminServices, IUserAdminService };
export default UserAdminServices;


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/admin/services/user-service.ts